import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./banner.css";

const words = [
  "Governments",
  "Small-Businesses",
  "Startups",
  "Enterprises",
  "Institutions",
];

const Banner = () => {
  const lettersRef = useRef(null);
  const [currentWordIndex, setCurrentWordIndex] = useState(0);

  useEffect(() => {
    const showWord = (word) => {
      const container = lettersRef.current;
      if (!container) return;

      // Temporary span to measure width
      const tempSpan = document.createElement("span");
      tempSpan.style.visibility = "hidden";
      tempSpan.style.position = "absolute";
      tempSpan.style.whiteSpace = "nowrap";
      tempSpan.className = "text-[2.5rem] md:text-[5rem] font-bold";
      tempSpan.textContent = word;
      document.body.appendChild(tempSpan);
      const newWidth = tempSpan.offsetWidth + 20;
      container.style.width = `${newWidth}px`;
      document.body.removeChild(tempSpan);

      container.innerHTML = "";
      [...word].forEach((char, i) => {
        const span = document.createElement("span");
        span.textContent = char;
        span.classList.add("letter");
        container.appendChild(span);
        setTimeout(() => span.classList.add("show"), i * 100);
      });
    };

    showWord(words[currentWordIndex]);

    const interval = setInterval(() => {
      setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [currentWordIndex]);

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#020617] text-white px-4">
      {/* Grid background */}
      <div
        className="absolute inset-0 z-0"
        style={{
          background: "#020617",
          backgroundImage: `
              linear-gradient(to right, rgba(71,85,105,0.15) 1px, transparent 1px),
              linear-gradient(to bottom, rgba(71,85,105,0.15) 1px, transparent 1px),
              radial-gradient(circle at 50% 60%, rgba(236,72,153,0.15) 0%, rgba(168,85,247,0.05) 40%, transparent 70%)
            `,
          backgroundSize: "40px 40px, 40px 40px, 100% 100%",
        }}
      />
      {/* Main Container */}
      <div className="relative z-20 flex flex-col items-center text-center w-full">
        {/* Availability Badge */}
        <div className="availability bg-[#2b1f4e] text-white text-sm font-medium font-inter px-5 py-2 rounded-full inline-flex items-center gap-2 mb-8 transition-all duration-200 hover:-translate-y-1 hover:shadow-md">
          <span className="w-2 h-2 bg-white rounded-full"></span>
          Available for New Projects
        </div>

        {/* Heading */}
        <div className="text-[clamp(2rem,5vw,4rem)] font-bold tracking-tight leading-snug mb-4 px-2 sm:px-4">
          <p className="mb-4 break-words sm:break-normal">
            We engineer software that empowers
          </p>
        </div>

        {/* Animated Word */}
        <h1 className="text-[clamp(2rem,5vw,4rem)] font-bold tracking-tight leading-snug mb-4 transition-all ease-in-out duration-500 px-2 sm:px-4">
          <div className="word-container inline-flex relative items-center justify-center px-5 h-[50px] sm:h-[70px] md:h-[90px] transition-all ease-in-out duration-500">
            <div className="word-border top-left absolute w-4 h-4 border-2 bg-[#2b1f4e] border-[#6c4ec5] left-3 -top-2 md:top-1 lg:-top-3"></div>
            <div className="word-border top-right absolute w-4 h-4 border-2 bg-[#2b1f4e] border-[#6c4ec5] right-3 -top-2 md:top-1 lg:-top-3"></div>
            <div className="word-border bottom-left absolute w-4 h-4 border-2 bg-[#2b1f4e] border-[#6c4ec5] left-3 -bottom-2 md:bottom-1 lg:-bottom-3"></div>
            <div className="word-border bottom-right absolute w-4 h-4 border-2 bg-[#2b1f4e] border-[#6c4ec5] right-3 -bottom-2 md:bottom-1 lg:-bottom-3"></div>
            <span
              id="lettersContainer"
              ref={lettersRef}
              className="letters-container inline-block border-2 border-[#6c4ec5] px-2 py-1 whitespace-nowrap transition-all duration-500 overflow-hidden"
            ></span>
          </div>
        </h1>

        {/* Subtitle */}
        <p className="subtitle text-base sm:text-lg max-w-md text-whitemt-10 font-inter z-10">
          We don't just build software — we craft solutions that move your
          business forward.
        </p>

        {/* CTA Button with left-to-right gradient wipe */}
        <Link to="/contact-us-v2/#contact-form">
          <div
            className="
group
relative
mt-12
inline-block
px-6 py-3
text-lg
rounded-lg
font-medium font-inter
tracking-tighter
text-white
shadow-md
[background:linear-gradient(#000,#000)_padding-box,linear-gradient(90deg,#ea580c,#d946ef)_border-box]
        [border:2px_solid_transparent]

overflow-hidden
transition-all duration-200 ease-out
active:translate-y-0.5
z-10
"
          >
            <span
              className="
relative
z-10
"
            >
              Start Your Project
            </span>
            {/* Soft powder fill layer */}
            <span
              className="
absolute
inset-0
before:content-['']
before:absolute
before:inset-0
before:w-[120%]
before:bg-[linear-gradient(to_right,_#ea580c_0%,_#c026d3_80%,_transparent_100%)]
before:-translate-x-full
before:transition-transform
before:duration-200
before:ease-out
group-hover:before:translate-x-0
"
            />
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Banner;
